/**
 * Shared field chrome — Input, Textarea, Select, DateField.
 * Heights match Button md (h-11 / 44px). No transform motion.
 */
import { clsx } from "clsx";

export const CONTROL_HEIGHT = {
    sm: "h-9",
    md: "h-11",
    lg: "h-[52px]",
} as const;

/** Border + surface + hover/focus/active — keep in sync across text fields */
export function fieldSurfaceClass(opts?: { error?: boolean; disabled?: boolean }) {
    return clsx(
        "w-full rounded-xl border bg-white text-sm text-neutral-ink",
        "placeholder:text-neutral-secondary/70",
        "dark:bg-white/[0.04] dark:text-white dark:placeholder:text-slate-500",
        "outline-none",
        // resting
        !opts?.error && "border-neutral-border/60 dark:border-white/10",
        // hover (pointer)
        !opts?.error &&
            !opts?.disabled &&
            "hover:border-primary/45 dark:hover:border-gold/50",
        // focus / focus-visible
        !opts?.error &&
            "focus:border-primary focus:ring-2 focus:ring-primary/20 dark:focus:border-gold dark:focus:ring-gold/25",
        !opts?.error &&
            "focus-visible:border-primary focus-visible:ring-2 focus-visible:ring-primary/20 dark:focus-visible:border-gold dark:focus-visible:ring-gold/25",
        // active
        !opts?.error && "active:border-primary dark:active:border-gold",
        // error
        opts?.error &&
            "border-danger hover:border-danger focus:border-danger focus:ring-2 focus:ring-danger/20 focus-visible:border-danger focus-visible:ring-danger/20",
        opts?.disabled && "cursor-not-allowed opacity-50",
    );
}

export const fieldIconClass =
    "pointer-events-none absolute top-1/2 z-[1] -translate-y-1/2 text-primary dark:text-gold-light [&_svg]:h-[18px] [&_svg]:w-[18px]";

export const fieldAddonClass =
    "inline-flex h-11 shrink-0 items-center border border-neutral-border bg-neutral-light px-3 text-sm text-neutral-secondary dark:border-white/12 dark:bg-white/[0.06] dark:text-slate-400";

/**
 * Hide the native browser date/time picker glyph and stretch an invisible
 * hit-target so clicks still open the picker; Maeiz icons remain visible.
 */
export const nativeDateIndicatorClass = clsx(
    // Hide native glyph; keep full-field hit target so picker still opens.
    "[&::-webkit-calendar-picker-indicator]:absolute",
    "[&::-webkit-calendar-picker-indicator]:inset-0",
    "[&::-webkit-calendar-picker-indicator]:h-full",
    "[&::-webkit-calendar-picker-indicator]:w-full",
    "[&::-webkit-calendar-picker-indicator]:cursor-pointer",
    "[&::-webkit-calendar-picker-indicator]:opacity-0",
    "[&::-webkit-calendar-picker-indicator]:appearance-none",
    "[&::-webkit-inner-spin-button]:appearance-none",
    "[&::-webkit-clear-button]:hidden",
    // Firefox
    "[&::-moz-calendar-picker-indicator]:opacity-0",
    "[&::-moz-calendar-picker-indicator]:appearance-none",
);
